export const claimLabels = {
	['opt-mark-all']: 'Marcar todos',
	['opt-unmark-all']: 'Desmarcar todos',
	['registerNewPhase']: 'Cadastrar | Nova Fase',
	['registerNewClaim']: 'Cadastrar | Pedido',
	['editClaim']: 'Editar | Pedido',
	['register-claim']: 'Cadastrar pedido',
	['new-phase']: 'Nova fase',
	['other-phases']: 'Ver fases anteriores',
	['open']: 'abrir',
	['close']: 'fechar',
	['phase']: 'Fase',
	['quantity']: 'Quantidade',
	['total-initial']: 'Total Inicial',
	['total-updated']: 'Total Atualizado',
	['total-risk-involved']: 'Total Risco Envolvido',
	['btn-no-cancel']: 'Não, cancelar',
	['btn-back']: 'Voltar',
	['btn-continue']: 'Continuar',
	['btn-cancel']: 'Cancelar',
	['btn-register-new-phase']: 'Cadastrar nova fase',
	['btn-register-new-claim']: 'Cadastrar pedido',
	['btn-edit-claim']: 'Confirmar edição',
	['error-server-primary']: 'Ops... ocorreu um erro',
	['error-server-secondary']: 'Ocorreu um erro ao processar as informações',
	['no-legalrequests-registered']: 'Nenhum pedido cadastrado',
	['other-phase']: 'Fase anterior',
	['actual-phase']: 'Fase atual',
	['selected-claim']: 'Pedido selecionado',
	['select-the-claim-type']: 'Selecione o tipo de pedido',
	['claim-registered']: 'Pedido cadastrado',
	['new-phase-registered']: 'Nova fase cadastrada!',
};
